import { Component, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IRaceClass } from '../timing-tower/IRaceTiming';

@Component({
  selector: 'app-race-class',
  standalone: true,
  imports: [CommonModule],
  styleUrl: './race-class.component.css',
  template: `
    <div class="relative">
      <button
        class="dropdown-toggle btn btn-secondary inline-flex items-center gap-2"
        [style]="{
          border: '1px solid var(--border-default)',
          padding: '2px 5px',
          'font-size': '13px',
          background: 'transparent',
          'min-width': '120px',
          cursor: 'pointer',
          'border-radius': '6px',
        }"
        (click)="isOpen = !isOpen"
        type="button"
      >
        <span class="glyphicons filter text-xs"></span>
        {{ allSelected || !selectedClasses.length ? 'Classes' : selectedClasses.join(', ') }}
      </button>
      <ul
        *ngIf="isOpen"
        class="absolute right-0 top-full z-50 mt-0 max-h-56 w-30 overflow-y-auto rounded bg-surface-container text-white shadow-lg"
      >
        <li>
          <label
            class="flex items-center gap-2 text-on-surface border-b border-white/10 px-3 py-2 hover:bg-white/10 cursor-pointer"
          >
            <input
              type="checkbox"
              [checked]="allSelected"
              (change)="toggleAll($event)"
              class="accent-primary/40"
            />
            <div class="text-sm">All</div>
          </label>
        </li>
        <li *ngFor="let cls of classOptions">
          <label class="flex items-center gap-2 px-3 py-2 hover:bg-white/10 cursor-pointer">
            <input
              type="checkbox"
              [checked]="selectedClasses.includes(cls.name)"
              (change)="toggleClass(cls, $event)"
              class="accent-primary/40"
            />
            <div
              class="inline-block rounded px-2 py-1 text-xs"
              [style.color]="cls.foreground"
              [style.backgroundColor]="cls.background"
            >
              {{ cls.name }}
            </div>
          </label>
        </li>
      </ul>
    </div>
  `,
})
export class RaceClassComponent {
  @Input() classes: IRaceClass[] = [];
  @Output() selectionChange = new EventEmitter<string[]>();

  classOptions: IRaceClass[] = [];
  selectedClasses: string[] = [];
  allSelected = false;
  isOpen = false;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['classes']) {
      this.classOptions = this.classes ?? [];
      this.selectedClasses = [];
      this.allSelected = false;
    }
  }

  toggleAll(event: any) {
    this.allSelected = event.target.checked;
    if (this.allSelected) {
      this.selectedClasses = [...this.classOptions?.map((c) => c.name)];
    } else {
      this.selectedClasses = [];
    }
    this.emitSelection();
  }

  toggleClass(cls: IRaceClass, event: any) {
    if (event.target.checked) {
      if (!this.selectedClasses.includes(cls.name)) {
        this.selectedClasses = [...this.selectedClasses, cls.name];
      }
    } else {
      this.selectedClasses = this.selectedClasses.filter((c) => c !== cls.name);
    }
    this.allSelected = this.selectedClasses.length === this.classOptions.length;
    this.emitSelection();
  }

  emitSelection() {
    this.selectionChange.emit([...this.selectedClasses]);
  }
}
